export const ONBOARDING_TEMPLATE_KEY = "digital-screen-v1";
export const ONBOARDING_TEMPLATE_VERSION = 1;
export const ONBOARDING_POLICY_KEYS = [
    "terms_of_service",
    "privacy_policy",
    "non_phi_acknowledgment",
];
export const ONBOARDING_POLICY_DOCUMENT_VERSIONS = Object.freeze({
    non_phi_acknowledgment: "v1",
    privacy_policy: "v1",
    terms_of_service: "v1",
});
export const ONBOARDING_STATES = [
    "not_started",
    "in_progress",
    "blocked",
    "ready_for_go_live",
    "live",
];
export const ONBOARDING_READINESS_STATUSES = [
    "unknown",
    "not_ready",
    "ready",
    "regressed",
];
export const ONBOARDING_STEP_STATUSES = [
    "not_started",
    "in_progress",
    "blocked",
    "complete",
];
export const ONBOARDING_STEP_READINESS_RESULTS = [
    "unknown",
    "satisfied",
    "unsatisfied",
    "not_applicable",
];
export const ONBOARDING_STEP_DEFINITIONS = [
    {
        actionKey: "tenant:settings:manage",
        evidenceSource: "automated",
        helpArticleSlug: "set-up-your-organization",
        isBlocking: true,
        productPath: "/settings/organization",
        stepKey: "organization",
        title: "Organization",
    },
    {
        actionKey: "tenant:users:manage",
        evidenceSource: "automated",
        helpArticleSlug: "invite-your-team",
        isBlocking: true,
        productPath: "/settings/team",
        stepKey: "team",
        title: "Team",
    },
    {
        actionKey: "tenant:settings:manage",
        evidenceSource: "automated",
        helpArticleSlug: "configure-sites-and-screens",
        isBlocking: true,
        productPath: "/sites",
        stepKey: "sites_and_screens",
        title: "Sites and screens",
    },
    {
        actionKey: "content:manage",
        evidenceSource: "automated",
        helpArticleSlug: "prepare-fallback-content",
        isBlocking: true,
        productPath: "/content/fallback",
        stepKey: "fallback_content",
        title: "Fallback content",
    },
    {
        actionKey: "devices:lifecycle:manage",
        evidenceSource: "automated",
        helpArticleSlug: "pair-an-evaluation-player",
        isBlocking: true,
        productPath: "/fleet/pair",
        stepKey: "evaluation_player",
        title: "Evaluation player",
    },
    {
        actionKey: "content:manage",
        evidenceSource: "automated",
        helpArticleSlug: "publish-your-first-schedule",
        isBlocking: true,
        productPath: "/schedules",
        stepKey: "first_schedule",
        title: "First schedule",
    },
    {
        actionKey: "emergency:test",
        evidenceSource: "automated",
        helpArticleSlug: "run-safety-tests",
        isBlocking: true,
        productPath: "/onboarding/safety-tests",
        stepKey: "safety_tests",
        title: "Safety tests",
    },
    {
        actionKey: "onboarding:manage",
        evidenceSource: "manual",
        helpArticleSlug: "complete-go-live-review",
        isBlocking: true,
        productPath: "/onboarding/sign-off",
        stepKey: "go_live",
        title: "Go-live",
    },
];
const policyKeySet = new Set(ONBOARDING_POLICY_KEYS);
const stepKeySet = new Set(ONBOARDING_STEP_DEFINITIONS.map((step) => step.stepKey));
export function isOnboardingPolicyKey(value) {
    return policyKeySet.has(value);
}
export function isOnboardingStepKey(value) {
    return stepKeySet.has(value);
}
//# sourceMappingURL=onboarding.js.map